"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var SessionManager = /** @class */ (function () {
    function SessionManager(storage, browser) {
        this.storage = storage;
        this.session = storage.get('currentSession');
        this.browser = browser;
        this.initSession();
    }
    SessionManager.prototype.initSession = function () {
        if (this.session === null)
            this.resetSession();
        if (this.sessionHasExpired())
            this.resetSession();
        this.saveCurrentPath(this.browser.currentPathname);
    };
    SessionManager.prototype.resetSession = function () {
        this.session = {
            browseAbandonmentSent: false,
            date: new Date(),
            pageViewCounter: 0,
            pagesVisited: [],
            renderedCampaigns: [],
            miSent: false
        };
        this.saveSession();
    };
    Object.defineProperty(SessionManager.prototype, "currentSession", {
        get: function () {
            return this.session;
        },
        enumerable: false,
        configurable: true
    });
    SessionManager.prototype.addCampaignRendering = function (campaignID) {
        var campaignHasNotBeenRendered = this.session.renderedCampaigns.find(function (cid) { return cid === campaignID; }) === undefined;
        if (campaignHasNotBeenRendered) {
            this.session.renderedCampaigns.push(campaignID);
            this.saveSession();
        }
    };
    SessionManager.prototype.markMi = function () {
        this.session.miSent = true;
        this.saveSession();
    };
    SessionManager.prototype.saveCurrentPath = function (path) {
        this.session.pageViewCounter++;
        this.session.pagesVisited.push(path);
        this.saveSession();
    };
    SessionManager.prototype.saveContactSubscription = function (subscription) {
        var subscriptionStatusIsValid = ['subscribed', 'unsubscribed'].includes(subscription.status);
        var lastUpdated = new Date(subscription.lastUpdated);
        var lastUpdatedIsValid = !Number.isNaN(lastUpdated.valueOf());
        if (!subscriptionStatusIsValid || !lastUpdatedIsValid)
            return;
        this.session.subscription = {
            status: subscription.status,
            lastUpdated: lastUpdated
        };
        this.saveSession();
    };
    SessionManager.prototype.sessionHasExpired = function () {
        var sessionEnd = new Date();
        sessionEnd.setTime(sessionEnd.getTime() - constants_1.SESSION_DURATION);
        return new Date(this.session.date) < sessionEnd;
    };
    SessionManager.prototype.updateBrowseAbandonmentSent = function (sent) {
        this.session.browseAbandonmentSent = Boolean(sent);
        this.saveSession();
    };
    SessionManager.prototype.saveSession = function () {
        this.storage.set('currentSession', this.session);
    };
    return SessionManager;
}());
exports.default = SessionManager;
//# sourceMappingURL=data:application/json;base64,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